export default {
  lang: {
    reset: 'Resetovat',
    search: 'Filtr',
    expand: 'Rozšířit',
    collapse: 'Stow',
  },
};
